/** Tokens visuais — categorias loja (marca TNV) */
export const CATEGORIAS_ACCENT = "#F96030";
export const CATEGORIAS_INK = "#1a2035";

export const categoriasToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${CATEGORIAS_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
};

export const emptyStateSx = {
  py: 6,
  textAlign: "center",
  border: "1px dashed",
  borderColor: "grey.300",
  borderRadius: 2,
  bgcolor: "grey.50",
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${CATEGORIAS_ACCENT}, #e04a1a)`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 560,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${CATEGORIAS_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${CATEGORIAS_ACCENT}`,
};

export const treePanelSx = {
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 2,
  borderLeft: `4px solid ${CATEGORIAS_ACCENT}`,
  bgcolor: "background.paper",
  maxHeight: { xs: "50vh", md: "68vh" },
  overflow: "auto",
};

export const detailPanelSx = {
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 2,
  bgcolor: "background.paper",
  height: "100%",
};

export const actionIconSx = {
  color: CATEGORIAS_ACCENT,
  "&:hover": { bgcolor: "rgba(249, 96, 48, 0.08)" },
};
